export default "__VITE_ASSET__CU5HNufN__"